<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-row no-gutters justify="space-between" align="start">
        <v-col cols="12" sm="8" class="pb-0 pa-0 mb-3">
          <h3 class="darkblue--text fs-16 lh-16 font-weight-700">
            HISTORY LOG UPLOAD
          </h3>
          <v-breadcrumbs
            class="
              px-0
              subtitle-2
              py-0
              mt-2
              breadcrumbs-items
              custom-breadcrumbs
            "
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-col>
        <v-col cols="auto">
          <v-btn class="primary" @click="showFilterDialog = true">
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-layout class="table-po">
      <v-flex xs12>
        <v-card class="elevation-card rounded-12">
          <v-card-title class="mb-5">
            <v-flex xs9 class="font-weight-500"> HISTORY LOG UPLOAD </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getData(year)"> refresh </v-icon>
            </v-flex>
          </v-card-title>
          <v-data-table
            class="px-4 mt-2 nav-table"
            dense
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100]
            }"
            :fixed-header="true"
            height="480px"
          >
            <!-- <template v-slot:header>
           
            <thead>
              <tr>
                <th>
                  File Name
                </th>
                <th>
                  Category
                </th>
                <th>
                  Method
                </th>
                <th>
                  Uploaded By
                </th>
                <th>
                  uploaded At
                </th>
                <th>
                  Message
                </th>
                <th>
                  Action
                </th>
              </tr>
            </thead>
          </template> -->
            <template v-slot:body="{ items }">
              <tbody v-if="items.length > 0">
                <tr v-for="(item, index) in items" :key="index">
                  <td>
                    {{ item.filename ? item.filename : '-' }}
                  </td>
                  <td>
                    {{ item.category ? item.category : '-' }}
                  </td>
                  <td>
                    {{ item.method ? item.method : '-' }}
                  </td>
                  <td>
                    {{ item.user ? item.user.email : '-' }}
                  </td>
                  <td>
                    {{
                      item.uploaded_at ? formatDateTime(item.uploaded_at) : '-'
                    }}
                  </td>
                  <td>
                    {{ item.message ? item.message : '-' }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      icon
                      id="btn-download"
                      title="Download File"
                      class="my-1"
                      @click="downloadFile(item.id)"
                    >
                      <v-icon size="10px" color="primary">mdi-download</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      :id="'btn-detail' + item.id"
                      @click="detail(item)"
                      class="my-1"
                      title="See Invalid Data Detail"
                      :disabled="
                        item.message ===
                          'There are some invalid data. Please check again.' ||
                        item.message === 'PO Manual Complete success.'
                          ? false
                          : true
                      "
                    >
                      <v-icon color="green">remove_red_eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    colspan="7"
                    class="text-center"
                    style="border: 0.5px solid rgba(0, 0, 0, 0.12) !important"
                  >
                    No data displayed
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showFilterDialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">History Log Filter</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0 pt-2">
                <label class="textblack--text">Year</label>
                <date-picker
                  v-model="year"
                  type="year"
                  placeholder="Filter"
                  format="YYYY"
                  class="dashSearch filterSearch mb-4"
                >
                </date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn color="#bd1e19" dark @click="showFilterDialog = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="downloadFile()">
            <v-icon size="10px">mdi-download</v-icon> Download
          </v-btn>
          <v-btn color="primary" dark @click="setFilter()">
            <v-icon>mdi-filter-outline</v-icon> Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Detail Invalid Data</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <div class="px-0" v-if="historyCategory === 'PO Manual Complete'">
                <span
                  v-if="historyMessage !== 'PO Manual Complete success.'"
                  class="font-weight-medium subtitle-1 darkblue--text"
                >
                  Please check the invalid PO Manual Complete data below.
                </span>
                <v-col sm="12" class="px-0">
                  <template>
                    <v-simple-table
                      fixed-header
                      class="table-taxonomy"
                      style="max-width: 750px"
                    >
                      <template v-slot:default>
                        <VuePerfectScrollbar
                          class="drawer-menu--scroll"
                          :settings="scrollSettings"
                        >
                          <thead>
                            <tr>
                              <th class="text-left f-14">Delivery Date</th>
                              <th class="text-left f-14">IO Number</th>
                              <th class="text-left f-14">IO Description</th>
                              <th class="text-left f-14">PO Number</th>
                              <th class="text-left f-14">PO Description</th>
                              <th class="text-left f-14">Error Description</th>
                            </tr>
                          </thead>

                          <tbody v-if="itemsNotFound.length !== 0">
                            <tr
                              v-for="(item, index) in itemsNotFound"
                              :key="index"
                            >
                              <td>
                                {{
                                  formattedDate(item.field.delivery_date) || '-'
                                }}
                              </td>
                              <td>
                                {{ item.field.io_number || '-' }}
                              </td>
                              <td>
                                {{ item.field.io_description || '-' }}
                              </td>
                              <td>
                                {{ item.field.po_number || '-' }}
                              </td>
                              <td>
                                {{ item.field.po_item || '-' }}
                              </td>
                              <td>
                                {{ item.error.join(', ') }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td
                                colspan="12"
                                class="text-center"
                                style="
                                  border: 0.5px solid rgba(0, 0, 0, 0.12) !important;
                                "
                              >
                                No data displayed
                              </td>
                            </tr>
                          </tbody>
                        </VuePerfectScrollbar>
                      </template>
                    </v-simple-table>
                  </template>
                  <hr class="hr-line mb-5 mt-5" style="" />
                </v-col>
              </div>
              <div class="px-0" v-else>
                <span class="font-weight-medium subtitle-1 darkblue--text">
                  Please check the invalid PO & NON-PO BI data below.
                </span>
                <v-col sm="12" class="px-0">
                  <template>
                    <v-simple-table
                      fixed-header
                      class="table-taxonomy"
                      style="max-width: 750px"
                    >
                      <template v-slot:default>
                        <VuePerfectScrollbar
                          class="drawer-menu--scroll"
                          :settings="scrollSettings"
                        >
                          <thead>
                            <tr>
                              <th class="f-14">Controlling Area</th>
                              <th class="f-14">Exchange Rate</th>
                              <th class="f-14">GR Amount Loc Currency</th>
                              <th class="f-14">IR Amount Loc Currency</th>
                              <th class="f-14">Internal Order</th>
                              <th class="f-14">
                                Order Net Amount Doc Currency
                              </th>
                              <th class="f-14">
                                Order Net Amount Loc Currency
                              </th>
                              <th class="f-14">PO Currency</th>
                              <th class="f-14">PO Line Item Text</th>
                              <th class="f-14">PO Number</th>
                              <th class="f-14">PO Release Flag</th>
                              <th class="f-14">PO Release Status</th>
                              <th class="f-14">PO Date</th>
                              <th class="f-14">Release Indicator-Desc</th>
                              <th class="f-14">Vendor Name</th>
                              <th class="f-14">Error Description</th>
                            </tr>
                          </thead>

                          <tbody v-if="itemsNotFound.length !== 0">
                            <tr
                              v-for="(item, index) in itemsNotFound"
                              :key="index"
                            >
                              <td>
                                {{ item.field['Controlling Area'] || '-' }}
                              </td>
                              <td>
                                {{ item.field['Exchange Rate'] || '-' }}
                              </td>
                              <td class="text-right">
                                {{
                                  idr(item.field['GR Amount Loc Currency']) ||
                                    '-'
                                }}
                              </td>
                              <td class="text-right">
                                {{
                                  idr(item.field['IR Amount Loc Currency']) ||
                                    '-'
                                }}
                              </td>
                              <td>
                                {{ item.field['Internal Order'] || '-' }}
                              </td>
                              <td class="text-right">
                                {{
                                  idr(
                                    item.field['Order Net Amount Doc Currency']
                                  ) || '-'
                                }}
                              </td>
                              <td class="text-right">
                                {{
                                  idr(
                                    item.field['Order Net Amount Loc Currency']
                                  ) || '-'
                                }}
                              </td>
                              <td>
                                {{ item.field['PO Currency'] || '-' }}
                              </td>
                              <td>
                                {{ item.field['PO Line Item Text'] || '-' }}
                              </td>
                              <td>
                                {{ item.field['PO Number'] || '-' }}
                              </td>
                              <td>
                                {{ item.field['PO Release Flag'] || '-' }}
                              </td>
                              <td>
                                {{ item.field['PO Release Status'] || '-' }}
                              </td>
                              <td>
                                {{ formatDate(item.field['PO-Date']) || '-' }}
                              </td>
                              <td>
                                {{
                                  item.field['Release Indicator-Desc'] || '-'
                                }}
                              </td>
                              <td>
                                {{ item.field['Vendor - Name'] || '-' }}
                              </td>
                              <td>{{ item.error }}</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td
                                colspan="12"
                                class="text-center"
                                style="
                                  border: 0.5px solid rgba(0, 0, 0, 0.12) !important;
                                "
                              >
                                No data displayed
                              </td>
                            </tr>
                          </tbody>
                        </VuePerfectScrollbar>
                      </template>
                    </v-simple-table>
                  </template>
                  <hr class="hr-line mb-5 mt-5" style="" />
                </v-col>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="detailDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    VuePerfectScrollbar
  },
  mixins: [ACLMixin],
  data() {
    return {
      loading: false,
      progressDialogLoading: false,
      detailDialog: false,
      itemsNotFound: [],
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 10
      },
      breadcrumbs: [
        {
          text: 'PO & NON PO REPORT',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'HISTORY LOG UPLOAD',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      headers: [
        {
          text: 'File Name',
          value: 'filename',
          sortable: true
        },
        {
          text: 'Category',
          value: 'category',
          sortable: false
        },
        {
          text: 'Method',
          value: 'method',
          sortable: false
        },
        {
          text: 'Uploaded By',
          value: 'user',
          sortable: false
        },
        {
          text: 'Uploaded At',
          value: 'uploaded_at',
          sortable: false
        },
        {
          text: 'Message',
          value: 'message',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false
        }
      ],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      year: new Date(),
      showYear: moment(new Date()).format('YYYY'),
      showFilterDialog: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      historyCategory: '',
      historyMessage: ''
    };
  },
  mounted() {
    this.getData(this.year);
  },
  watch: {
    'options.page'() {
      this.getData(this.year);
    },
    'options.itemsPerPage'() {
      this.getData(this.year);
    }
  },
  methods: {
    getData(year) {
      this.progressDialogLoading = true;
      this.loading = true;
      let date = new Date();
      this.showYear = moment(year).format('YYYY');
      if (!year) {
        year = moment(date).format('YYYY');
      } else {
        year = moment(year).format('YYYY');
      }
      let { page, itemsPerPage } = this.options;
      return this.$store
        .dispatch('purchasingOrder/getHistoryLog', {
          year,
          page,
          limit: itemsPerPage
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.data;
            this.totalItems = Number(data.data.total);
            const pageData = data.data.page;
            const itemsPerPageData = data.data.perPage;
            this.options = { pageData, itemsPerPageData };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadFile(id) {
      window.open(
        this.baseUrl +
          '/v1/logs/purchasing-orders/download/' +
          id +
          '?token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    detail(item) {
      window.open(
        this.baseUrl +
          '/v1/logs/purchasing-orders/download-log/' +
          item.id +
          '?token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    setFilter() {
      this.progressDialogLoading = true;
      this.getData(this.year);
      this.showFilterDialog = false;
    }
  }
};
</script>
<style>
::-webkit-scrollbar {
  width: 8px !important;
}
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}

/* .table-po table {
  display: block;
} */
.table-non-po .v-data-table__wrapper {
  border-radius: 5px !important;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po .theme--light.v-data-table thead tr th {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: -0.02em !important;
  text-align: center !important;
  border-right: 1px solid #0000001f;
  height: 37px !important;
  color: #fff !important;
  background: #28a0f6 !important;
}
.table-po .theme--light.v-data-table tbody td {
  height: 30px !important;
  border-right: 0.5px solid rgba(0, 0, 0, 0.12);
  border-left: 0.5px solid rgba(0, 0, 0, 0.12);
}
</style>
